<template>
  <div class="flex w-full flex-col items-center space-y-6">
    <DashboardLink
      :to="{
        name: 'requestCreate',
      }"
      :icon="RequestCreateIcon"
    >
      beepaid
    </DashboardLink>

    <DashboardLink
      :to="{
        name: 'paymentsIndex',
      }"
      :icon="PaymentsListIcon"
    >
      payments
    </DashboardLink>

    <DashboardLink
      :to="{
        name: 'customersIndex',
      }"
      :icon="CustomersListIcon"
    >
      customers
    </DashboardLink>

    <DashboardLink :to="{ name: 'help' }" :icon="HelpIcon">
      help
    </DashboardLink>
  </div>
</template>

<script setup lang="ts">
import RequestCreateIcon from "~icons/beepaid/request-money"
import PaymentsListIcon from "~icons/beepaid/payments-hive"
import CustomersListIcon from "~icons/beepaid/customers"
import HelpIcon from "~icons/beepaid/help"
</script>
